'use strict';

import childProcess from 'child_process';
import fs from 'fs';
import path from 'path';
import log from 'fancy-log';
import pluginError from 'plugin-error';

const PLUGIN_NAME = 'test-runner';

interface PesterOptions {
    outputPath: string;
    srcPath: string;
    testPath: string;
    verbose: boolean;
    logIdentifier: string;
}

function runPester(options: PesterOptions, callback: Function) {
    const powerShell = 'powershell.exe';
    const script = path.normalize(__dirname + '..\\..\\..\\tools\\scripts\\Invoke-PesterTest.ps1');

    // get output directory
    const outputDir = path.dirname(options.outputPath);

    // make results dir if it doesn't exist
    if (!fs.existsSync(outputDir)) {
        fs.mkdirSync(outputDir);
    }

    const args = ['-NoProfile', '-File', script];
    if (options.srcPath) {
        args.push('-SrcPath', options.srcPath);
    }

    if (options.testPath) {
        args.push('-TestPath', options.testPath);
    }

    if (options.outputPath) {
        args.push('-OutputPath', options.outputPath);
    }

    if (!options.verbose) {
        args.push('-Quiet');
    }

    log(powerShell, args.join(' '));
    const cmd = childProcess.spawn(powerShell, args);
    const errors = [];

    cmd.stdout.on('data', function (data) {
        const message = data.toString().trim();
        if (message && message.length) {
            log(`${options.logIdentifier} - ${data.toString().trim()}`);
        }
    });

    cmd.stderr.on('data', function (data) {
        const message = data.toString().trim();
        if (message.toUpperCase().startsWith('ERROR')) {
            log.error(`${options.logIdentifier} - ${message}`);
            errors.push(`${options.logIdentifier} - ${message}`);
        } else if (message && message.length) {
            log(`${options.logIdentifier} - ${message}`);
        }
    });

    cmd.on('exit', function (code) {
        if (code !== 0) {
            callback('Powershell Unit tests failed. Please check the log for errors or failed tests.');
            return;
        }
        callback();
    });
}

interface TestOptions {
    pester?: PesterOptions;
}

type CallbackFunction = (err?: any) => void;

function run(options: TestOptions, callback: Function) {
    const tests: ((cb: CallbackFunction) => void)[] = [];
    const next = () => {
        if (tests.length > 0) {
            tests[0]((err) => {
                if (!err) {
                    // remove first test runner
                    tests.splice(0, 1);
                    // call next runner
                    next();
                } else {
                    callback(new pluginError({ plugin: PLUGIN_NAME, message: err }));
                }
            });
        } else {
            callback();
        }
    };

    if (options.pester) {
        tests.push((cb) => runPester(options.pester, cb));
    }

    next();
}

module.exports = run;
